module.exports = __webpack_public_path__ + "img/part2-icon1.5f54072b.png";